'use client';

import { webStorageUtil } from '@/lib/storage/webStorageUtil';
import { ELocalStorageKeys } from '@/lib/storage/enums';

interface SupportUrlParameters {
    playerIdParamName?: string;
    playerNameParamName?: string;
}

export const getUrlParam = (key: string) => {
    if (typeof window === 'undefined') return null;
    return new URLSearchParams(window.location.search).get(key);
}

export const getQueryParam = (key: string, search: string) => {
    return new URLSearchParams(search).get(key);
}

export const collectQueryParams = (search: string) => {
    return new URLSearchParams(search);
}

export const getUrlQueryParam = (key: string) => {
    if (typeof window === 'undefined') return null;
    return new URLSearchParams(window.location.search).get(key);
}
export const getHashParam = (key: string) => {
    const hash = window.location.hash;
    return new URLSearchParams(hash.replace('#', '')).get(key);
}

export const getSearchParam = (key: string) => {
    return new URLSearchParams(window.location.search).get(key);
}

export const getCheckoutTokenFromUrl = () => {
    return location.pathname.split('/').filter(Boolean)[2];
}

export const buildShopUrlFromCampaignTokenUrl = (token: string) => {
    return `/shop${location.search ? location.search + '&' : '?'}from=campaign&token=${token}`;
}

/** Logged-in checkout deep link on `/login/.../token` — same as store-frontend (no merge of unrelated search params). */
export const buildShopUrlForLoggedInCampaignCheckout = (campaignToken: string) => {
    return `/shop?from=campaign&token=${campaignToken}`;
}

export const getCampaignTokenFromUrl = () => {
    return location.pathname.split('/').filter(Boolean)[2];
}

export const handleUrlParams = () => {

}

export const isFromCampaign = (): boolean => {
    if (typeof window === 'undefined') return false;
    const pathname = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);

    const hasCampaignPath = pathname.includes('/campaign/');
    const hasJwtParam = searchParams.has('jwt');
    const hasFromCampaign = searchParams.get('from') === 'campaign';

    return hasCampaignPath || hasJwtParam || hasFromCampaign;
}

export const openLink = (url: string, openInNewTab: boolean = false): void => {
    if (openInNewTab) {
        window.open(url, '_blank', 'noopener,noreferrer');
    } else {
        window.open(url, '_self');
    }
};

const REFUND_BASE_URL = 'https://help.appcharge.com/hc/en-us/requests/new';
const REFUND_TOPIC_PARAM = 'tf_25438680794909';
const REFUND_TOPIC_VALUE = 'b2c_ticket_topic_refund';
const REFUND_PLAYER_ID_PARAM = 'tf_25438695019421';
const REFUND_PROJECT_ID_PARAM = 'tf_25438782685085';
const REFUND_COUNTRY_PARAM = 'tf_25438841537437';

export const buildRefundUrl = (playerId?: string, publisherId?: string, playerCountry?: string): string => {
    const url = new URL(REFUND_BASE_URL);
    url.searchParams.set(REFUND_TOPIC_PARAM, REFUND_TOPIC_VALUE);
    if (playerId) url.searchParams.set(REFUND_PLAYER_ID_PARAM, playerId);
    if (publisherId) url.searchParams.set(REFUND_PROJECT_ID_PARAM, publisherId);
    if (playerCountry) url.searchParams.set(REFUND_COUNTRY_PARAM, playerCountry);
    return url.toString();
};

export const buildSupportUrl = (
    baseUrl: string,
    supportParameters?: SupportUrlParameters
): string => {
    if (!supportParameters) return baseUrl;

    try {
        const url = new URL(baseUrl.startsWith('http') ? baseUrl : `https://${baseUrl}`);
        const playerData = webStorageUtil.get(ELocalStorageKeys.SESSION_DATA);
        const { playerIdParamName, playerNameParamName } = supportParameters;

        if (playerIdParamName && playerData?.playerId) {
            url.searchParams.set(playerIdParamName, playerData.playerId);
        }

        if (playerNameParamName && playerData?.playerName) {
            url.searchParams.set(playerNameParamName, playerData.playerName);
        }

        return url.toString();
    } catch (error) {
        console.error('Error building support URL:', error);
        return baseUrl;
    }
};